module.exports = __webpack_public_path__ + "img/078-student-monochrome.8456cae6.svg";